<p class="font-accent text-3.5xl text-white text-center leading-9">
  {{ text }}
</p>
